import React, { useContext } from "react";

import { GlobalContext } from "@/contexts";
import Svg from "@/styles/utils/Svg";
import { isTouchDevice } from "@/utils/getters";

import { Icon } from "./styles";

export type SharingProps = {
  onShareClick: (type: SharingType) => void;
  customIconSize?: number;
};

export enum SharingType {
  x = "x",
  whatsApp = "whatsapp",
  facebook = "facebook",
}

const Sharing: React.FC<SharingProps> = (
  props: SharingProps
): React.JSX.Element => {
  const { customIconSize, onShareClick } = props;
  const globalContext = useContext(GlobalContext);
  const { icons } = globalContext;

  const iconSize = customIconSize || 20;
  const mobileIconSize = customIconSize || 22;

  return (
    <React.Fragment>
      <Icon onClick={() => onShareClick(SharingType.facebook)}>
        <Svg contents={icons.Facebook} height={iconSize} width={iconSize} />
      </Icon>
      <Icon onClick={() => onShareClick(SharingType.x)}>
        <Svg contents={icons.X} height={iconSize} width={iconSize} />
      </Icon>
      {isTouchDevice() && (
        <Icon onClick={() => onShareClick(SharingType.whatsApp)}>
          <Svg
            contents={icons.WhatsApp}
            height={mobileIconSize}
            width={mobileIconSize}
          />
        </Icon>
      )}
    </React.Fragment>
  );
};

export default Sharing;
export { Sharing };
